export const participationsRoutePaths = {
  list: () => "/my-account/participations/list",
  assemblies: () => "/my-account/participations/assemblies",
  assembly: (id?: string) => `/my-account/participations/assemblies/${id}`,
  assemblyDetail: (id?: string) =>
    `/my-account/participations/assemblies/${id}/detail`,
  assemblyDetailVote: (id?: string) =>
    `/my-account/participations/assemblies/${id}/detail/vote`,
  assemblyDetailDocuments: (id?: string) =>
    `/my-account/participations/assemblies/${id}/detail/documents`,
  assemblyVoteForm: (id?: string) =>
    `/my-account/participations/assemblies/${id}/vote-form`,
  assemblyVoteSignature: (id?: string) =>
    `/my-account/participations/assemblies/${id}/vote-signature`,
  reportings: () => "/my-account/participations/reportings",
  reportingDetail: (id?: string) =>
    `/my-account/participations/reportings/${id}`,
  certificates: () => "/my-account/participations/certificates",
} as const;
